import { render, staticRenderFns } from "./GCompetencyAcademicAbility.vue?vue&type=template&id=75080d00&scoped=true&"
import script from "./GCompetencyAcademicAbility.vue?vue&type=script&lang=ts&"
export * from "./GCompetencyAcademicAbility.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75080d00",
  null
  
)

export default component.exports